export let displayedColumns: string[] = [
  'station',
  'district',
  'municipality',
  'basin',
  'river',
  'valueOnDate24HMax',
  'date24HMax',
  'valueOnDateRef',
  'dateRef',
];

export let displayedNames: any = {
  station: 'Località',
  district: 'Provincia',
  municipality: 'Comune',
  basin: 'Bacino',
  river: "Corso d'acqua",
  valueOnDate24HMax: 'Massimo nelle 24H[m]',
  date24HMax: 'Ora locale del massimo',
  valueOnDateRef: "Valore all'ora di rif.[m]",
  dateRef: 'Ora di rif.',
};
